import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteUnterpullendorf() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-unterpullendorf-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-unterpullendorf-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="unterpullendorf" />
      </div>
    </div>
  );
}

export default BodenfeuchteUnterpullendorf;
